import { useQuery } from "@tanstack/react-query";
import drEasyApi from "../Api/Customapi";

const getUserData = async () => {
  const { data } = await drEasyApi.get("/api/doctor/User/GetUserData");
  return data;
};

export const useGetUserData = () => {
  return useQuery({
    queryKey: ["userData"],
    queryFn: getUserData,
    refetchOnWindowFocus: false,
  });
};
